<template>
  <div id="container" class="col-12">
    <div id="TituloDetalleDeDocumento_div">
      <h2 class="label-black" style="margin-bottom: 0px;">Detalle de Evaluación</h2>
    </div>
    <div class="row d-flex">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
        <div class="area custom-area">
            <div class="row" style="margin-top:20px">
              <div class="col-2">
                <router-link v-if="idSolicitud!=null" :to="{ name: 'DetalleSolicitudEvaluacion', params: {idSolicitud: idSolicitud } }">
                  <button type="button" class="form-control btn-custom btn-sm"><i class="fa fa-arrow-left"></i><span class="col-form-label" style="margin-left:50px">Regresar</span></button>
                </router-link>
                <button type="button" class="form-control btn-custom btn-sm" v-else @click="$router.go(-1)"><i class="fa fa-arrow-left"></i><span class="col-form-label" style="margin-left:50px">Regresar</span></button>
              </div>
            </div>
            <div class="row">
              <div class="col-3" style="border-right:solid;padding-right:20px;">
                <div class="row">
                  <div class="col-12"><h4 class="label-black">Persona Evaluada</h4></div>
                </div>
                <div class="row" style="margin-top:10px;margin-bottom:10px;">
                  <div class="col-12 d-flex justify-content-center" style="overflow:hidden">
                    <img src="../../../assets/usuario-sin-foto.png" class="thumb" />
                  </div>
                  <div class="col-12">
                    <div class="row"><span class="col-form-label label-black"><b>Evaluado : </b>{{nombreEvaluado}}</span></div>
                    <div class="row"><span class="col-form-label label-black"><b>Estatus : </b>{{estatus}}</span></div>
                    <div class="row"><span class="col-form-label label-black"><b>Sección : </b>{{seccion}}</span></div>
                    <div class="row"><span class="col-form-label label-black"><b>Departamento : </b>{{departamento}}</span></div>
                    <div class="row"><span class="col-form-label label-black"><b>Puesto : </b>{{puesto}}</span></div>
                    <div class="row"><span class="col-form-label label-black"><b>Tipo Puesto : </b>{{tipoPuesto}}</span></div>
                    <div class="row"><span class="col-form-label label-black"><b>Periodo a Evaluar : </b>{{periodoEvaluacion}}</span></div>
                  </div>
                </div>
              </div>
              <div class="col-9">
                <div class="row">
                  <div class="col-5">
                    <h5>
                      <span class="col-form-label label-black">
                        Evaluadores Asignados <span class="badge badge-light">{{evaluadoresAsignados}}</span>
                      </span>
                    </h5>
                  </div>
                  <div class="col-3"></div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <ul class="nav nav-tabs" id="tabAltaUsuario" role="tablist">
                      <li class="nav-item">
                        <a class="nav-link active" id="Evaluadores-tab" data-toggle="tab" href="#Evaluadores" role="tab" aria-controls="Evaluadores" aria-selected="true">Evaluadores</a>
                      </li>
                      <li class="nav-item" v-if="terminado">
                        <a class="nav-link" id="Comentarios-tab" data-toggle="tab" href="#Comentarios" role="tab" aria-controls="Comentarios" aria-selected="false">Comentarios</a>
                      </li>
                      <li class="nav-item" v-if="terminado">
                        <a class="nav-link" id="Resultados-tab" data-toggle="tab" href="#Resultados" role="tab" aria-controls="Resultados" aria-selected="false">Resultados</a>
                      </li>
                      <li class="nav-item" v-if="terminado">
                        <a class="nav-link" id="FO-tab" data-toggle="tab" href="#FO" role="tab" aria-controls="FO" aria-selected="false">Fortalezas y Oportunidades</a>
                      </li>
                      <li class="nav-item" v-if="terminado">
                        <a class="nav-link" id="Comentario-tab" data-toggle="tab" href="#Comentario" role="tab" aria-controls="Comentario" aria-selected="false">Agregar Comentario</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade show active" id="Evaluadores" role="tabpanel" aria-labelledby="general-tab">
                    <div class="row" style="margin-top:30px;">
                      <div class="col-12">
                        <table class="table table-striped table-light table-hover" id="tablaEvaluadores2">
                          <thead class="thead-custom">
                            <tr>
                              <th class="text-center">ID Evaluador</th>
                              <th class="text-center">Nombre de evaluador</th>
                              <th class="text-center">Puesto</th>
                              <th class="text-center">Tipo de Evaluador</th>
                              <th class="text-center">Estatus de evaluación</th>
                            </tr>
                          </thead>
                          <tbody class='text-dark'>
                            <tr v-for='evaluador in evaluadores'>
                              <td>{{evaluador.Evaluador.NumeroNomina }}</td>
                              <td>{{evaluador.Evaluador.NombreCompleto}}</td>
                              <td>{{evaluador.Evaluador.Puesto}}</td>
                              <td>{{evaluador.TipoEvaluador}} / {{evaluador.FormatoCuestionario}}</td>
                              <td>{{evaluador.EstatusEvaluacion}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade show" id="Comentarios" role="tabpanel" aria-labelledby="general-tab">
                    <div class="row" style="margin-top:30px;">
                      <div class="col-12">
                        <table class="table table-striped table-light table-hover" id="tablaComentarios">
                          <thead class="thead-custom">
                            <tr>
                              <th class="text-center">Comentarios</th>
                            </tr>
                          </thead>
                          <tbody class='text-dark'>
                            <tr>
                              <td>
                                <ul v-for="evaluador in evaluadores">
                                  <li v-if="evaluador.Observaciones != null && evaluador.Observaciones != ''">{{evaluador.Observaciones}}</li>
                                </ul>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade" v-if="terminado" id="Resultados" role="tabpanel" aria-labelledby="Resultados-tab">
                    <div class="row">
                      <div class="col-12">
                        <ul class="nav nav-tabs" id="tabResultados" role="tablist">
                          <li class="nav-item">
                            <a class="nav-link active" id="Poligono-tab" data-toggle="tab" href="#Poligono" role="tab" aria-controls="Poligono" aria-selected="true">Poligono</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" id="Barras-tab" data-toggle="tab" href="#Barras" role="tab" aria-controls="Barras" aria-selected="false">Barras</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="tab-content" id="myTabContent">
                      <div class="tab-pane fade show active" id="Poligono" role="tabpanel" aria-labelledby="Poligono-tab">
                        <div class="row" style="margin-top:30px; margin-left:20px;">
                          <div class="col-12">
                            <highcharts :options="chartOptions" style="min-height:500px"></highcharts>
                          </div>
                        </div>
                      </div>
                      <div class="tab-pane fade" id="Barras" role="tabpanel" aria-labelledby="Barras-tab">
                        <div class="row" style="margin-top:30px; margin-left:20px;">
                          <div class="col-12">
                            <highcharts :options="chartOptions2" style="min-height:500px"></highcharts>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade" v-if="terminado" id="FO" role="tabpanel" aria-labelledby="FO-tab">

                    <div class="row" style="margin-top:10px;">
                      <div class="col-12">
                        <table class="table table-striped table-light table-hover" id="tablaEvaluadores">
                          <thead class="thead-custom">
                            <tr>
                              <th>Fortalezas</th>
                              <th>Areas de Oportunidad</th>
                            </tr>
                          </thead>
                          <tbody class="text-dark">
                            <tr>
                              <td><ul><li v-for="Fortaleza in Fortalezas">{{Fortaleza}}</li></ul><span v-if="Fortalezas.length <= 0">No se detectaron fortalezas.</span></td>
                              <td><ul><li v-for="Oportunidad in Oportunidades">{{Oportunidad}}</li></ul><span v-if="Oportunidades.length <= 0">No se detectaron areas de oportunidad.</span></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                  </div>
                  <div class="tab-pane fade" v-if="terminado" id="Comentario" role="tabpanel" aria-labelledby="Comentario-tab">
                    <div class="row" style="margin-top:20px;">
                      <h5>¿Que tipo de comentarios recibió el evaluado?</h5>
                    </div>
                    <div class="row" style="margin-top:10px;">
                      <div class="col-3"></div>
                      <div class="col-3"><i class='fa fa-thumbs-up fa-5x' id="bueno" @click="calificarComentarios(false)"></i></div>
                      <div class="col-3"><i class='fa fa-thumbs-down fa-5x' id="malo" @click="calificarComentarios(true)"></i></div>
                    </div>
                    <div class="row" style="margin-top:20px;" v-if="filtroComentariosNegativos">
                      <div class="col-3"></div>
                      <div class="col-4>"><h6>¿Sobre que competencias se recibieron comentarios negativos?</h6></div>
                    </div>
                    <div class="row" style="margin-top:10px;" v-if="filtroComentariosNegativos">
                      <div class="col-3"></div>
                      <div class="col-4 scroll">
                        <template v-for="(leyenda,indice) in leyendasEspecificas">
                          <div class="row leyenda">
                            <div class="col-1"><input type="checkbox" @change="actualizarComentario" v-model="banderasLeyendas[indice]" /></div>
                            <div class="col-11">{{leyenda.CategoriaDeObservacion}}</div>
                          </div>
                        </template>
                      </div>
                    </div>
                    <div class="row" style="margin-top:20px;">
                      <div class="col-12">
                        <textarea class="form-control" cols="15" rows="5" v-model="comentario" readOnly style="background-color: #504f54"></textarea>
                      </div>
                    </div>
                    <div class="row" style="margin-top:30px;">
                      <div class="col-9"></div>
                      <div class="col-3">
                        <input type="button" value="Guardar y Enviar" class="form-control" @click="guardarComentario" v-bind:disabled="comentado" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>

    <!-- <div slot="main">
      <div class="container-fluid">
        <div class="row" style="margin-top:20px">
          <div class="col-2">
            <router-link v-if="idSolicitud!=null" :to="{ name: 'DetalleSolicitudEvaluacion', params: {idSolicitud: idSolicitud } }">
              <button type="button" class="form-control"><i class="fa fa-arrow-left"></i><span class="col-form-label" style="margin-left:50px">Regresar</span></button>
            </router-link>
            <button type="button" class="form-control" v-else @click="$router.go(-1)"><i class="fa fa-arrow-left"></i><span class="col-form-label" style="margin-left:50px">Regresar</span></button>
          </div>
        </div>
        <div class="row">
          <div class="col-3" style="border-right:solid;padding-right:20px;">
            <div class="row">
              <div class="col-12"><h4><span class="col-form-label">Persona Evaluada</span></h4></div>
            </div>
            <div class="row" style="margin-top:10px;margin-bottom:10px;">
              <div class="col-12 d-flex justify-content-center" style="overflow:hidden">
                <img src="../../../assets/usuario-sin-foto.png" class="thumb" />
              </div>
              <div class="col-12">
                <div class="row"><span class="col-form-label"><b>Evaluado : </b>{{nombreEvaluado}}</span></div>
                <div class="row"><span class="col-form-label"><b>Estatus : </b>{{estatus}}</span></div>
                <div class="row"><span class="col-form-label"><b>Sección : </b>{{seccion}}</span></div>
                <div class="row"><span class="col-form-label"><b>Departamento : </b>{{departamento}}</span></div>
                <div class="row"><span class="col-form-label"><b>Puesto : </b>{{puesto}}</span></div>
                <div class="row"><span class="col-form-label"><b>Tipo Puesto : </b>{{tipoPuesto}}</span></div>
                <div class="row"><span class="col-form-label"><b>Periodo a Evaluar : </b>{{periodoEvaluacion}}</span></div>
              </div>
            </div>
          </div>
          <div class="col-9">
            <div class="row">
              <div class="col-5">
                <h5>
                  <span class="col-form-label">
                    Evaluadores Asignados <span class="badge badge-light">{{evaluadoresAsignados}}</span>
                  </span>
                </h5>
              </div>
              <div class="col-3"></div>
            </div>

            <div class="row">
              <div class="col-12">
                <ul class="nav nav-tabs" id="tabAltaUsuario" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link active" id="Evaluadores-tab" data-toggle="tab" href="#Evaluadores" role="tab" aria-controls="Evaluadores" aria-selected="true">Evaluadores</a>
                  </li>
                  <li class="nav-item" v-if="terminado">
                    <a class="nav-link" id="Comentarios-tab" data-toggle="tab" href="#Comentarios" role="tab" aria-controls="Comentarios" aria-selected="false">Comentarios</a>
                  </li>
                  <li class="nav-item" v-if="terminado">
                    <a class="nav-link" id="Resultados-tab" data-toggle="tab" href="#Resultados" role="tab" aria-controls="Resultados" aria-selected="false">Resultados</a>
                  </li>
                  <li class="nav-item" v-if="terminado">
                    <a class="nav-link" id="FO-tab" data-toggle="tab" href="#FO" role="tab" aria-controls="FO" aria-selected="false">Fortalezas y Oportunidades</a>
                  </li>
                  <li class="nav-item" v-if="terminado">
                    <a class="nav-link" id="Comentario-tab" data-toggle="tab" href="#Comentario" role="tab" aria-controls="Comentario" aria-selected="false">Agregar Comentario</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show active" id="Evaluadores" role="tabpanel" aria-labelledby="general-tab">
                <div class="row" style="margin-top:30px;">
                  <div class="col-12">
                    <table class="table table-striped table-light table-hover" id="tablaEvaluadores2">
                      <thead class="thead-custom">
                        <tr>
                          <th class="text-center">ID Evaluador</th>
                          <th class="text-center">Nombre de evaluador</th>
                          <th class="text-center">Puesto</th>
                          <th class="text-center">Tipo de Evaluador</th>
                          <th class="text-center">Estatus de evaluación</th>
                        </tr>
                      </thead>
                      <tbody class='text-dark'>
                        <tr v-for='evaluador in evaluadores'>
                          <td>{{evaluador.Evaluador.NumeroNomina }}</td>
                          <td>{{evaluador.Evaluador.NombreCompleto}}</td>
                          <td>{{evaluador.Evaluador.Puesto}}</td>
                          <td>{{evaluador.TipoEvaluador}} / {{evaluador.FormatoCuestionario}}</td>
                          <td>{{evaluador.EstatusEvaluacion}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade show" id="Comentarios" role="tabpanel" aria-labelledby="general-tab">
                <div class="row" style="margin-top:30px;">
                  <div class="col-12">
                    <table class="table table-striped table-light table-hover" id="tablaComentarios">
                      <thead class="thead-custom">
                        <tr>
                          <th class="text-center">Comentarios</th>
                        </tr>
                      </thead>
                      <tbody class='text-dark'>
                        <tr>
                          <td>
                            <ul v-for="evaluador in evaluadores">
                              <li v-if="evaluador.Observaciones != null && evaluador.Observaciones != ''">{{evaluador.Observaciones}}</li>
                            </ul>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" v-if="terminado" id="Resultados" role="tabpanel" aria-labelledby="Resultados-tab">
                <div class="row">
                  <div class="col-12">
                    <ul class="nav nav-tabs" id="tabResultados" role="tablist">
                      <li class="nav-item">
                        <a class="nav-link active" id="Poligono-tab" data-toggle="tab" href="#Poligono" role="tab" aria-controls="Poligono" aria-selected="true">Poligono</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" id="Barras-tab" data-toggle="tab" href="#Barras" role="tab" aria-controls="Barras" aria-selected="false">Barras</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade show active" id="Poligono" role="tabpanel" aria-labelledby="Poligono-tab">
                    <div class="row" style="margin-top:30px; margin-left:20px;">
                      <div class="col-12">
                        <highcharts :options="chartOptions" style="min-height:500px"></highcharts>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="Barras" role="tabpanel" aria-labelledby="Barras-tab">
                    <div class="row" style="margin-top:30px; margin-left:20px;">
                      <div class="col-12">
                        <highcharts :options="chartOptions2" style="min-height:500px"></highcharts>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" v-if="terminado" id="FO" role="tabpanel" aria-labelledby="FO-tab">

                <div class="row" style="margin-top:10px;">
                  <div class="col-12">
                    <table class="table table-striped table-light table-hover" id="tablaEvaluadores">
                      <thead class="thead-custom">
                        <tr>
                          <th>Fortalezas</th>
                          <th>Areas de Oportunidad</th>
                        </tr>
                      </thead>
                      <tbody class="text-dark">
                        <tr>
                          <td><ul><li v-for="Fortaleza in Fortalezas">{{Fortaleza}}</li></ul><span v-if="Fortalezas.length <= 0">No se detectaron fortalezas.</span></td>
                          <td><ul><li v-for="Oportunidad in Oportunidades">{{Oportunidad}}</li></ul><span v-if="Oportunidades.length <= 0">No se detectaron areas de oportunidad.</span></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

              </div>
              <div class="tab-pane fade" v-if="terminado" id="Comentario" role="tabpanel" aria-labelledby="Comentario-tab">
                <div class="row" style="margin-top:20px;">
                  <h5>¿Que tipo de comentarios recibió el evaluado?</h5>
                </div>
                <div class="row" style="margin-top:10px;">
                  <div class="col-3"></div>
                  <div class="col-3"><i class='fa fa-thumbs-up fa-5x' id="bueno" @click="calificarComentarios(false)"></i></div>
                  <div class="col-3"><i class='fa fa-thumbs-down fa-5x' id="malo" @click="calificarComentarios(true)"></i></div>
                </div>
                <div class="row" style="margin-top:20px;" v-if="filtroComentariosNegativos">
                  <div class="col-3"></div>
                  <div class="col-4>"><h6>¿Sobre que competencias se recibieron comentarios negativos?</h6></div>
                </div>
                <div class="row" style="margin-top:10px;" v-if="filtroComentariosNegativos">
                  <div class="col-3"></div>
                  <div class="col-4 scroll">
                    <template v-for="(leyenda,indice) in leyendasEspecificas">
                      <div class="row leyenda">
                        <div class="col-1"><input type="checkbox" @change="actualizarComentario" v-model="banderasLeyendas[indice]" /></div>
                        <div class="col-11">{{leyenda.CategoriaDeObservacion}}</div>
                      </div>
                    </template>
                  </div>
                </div>
                <div class="row" style="margin-top:20px;">
                  <div class="col-12">
                    <textarea class="form-control" cols="15" rows="5" v-model="comentario" readOnly style="background-color: #504f54"></textarea>
                  </div>
                </div>
                <div class="row" style="margin-top:30px;">
                  <div class="col-9"></div>
                  <div class="col-3">
                    <input type="button" value="Guardar y Enviar" class="form-control" @click="guardarComentario" v-bind:disabled="comentado" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Vue from 'vue'
  import Vuex from 'vuex'
  import store from '@/store/index'
  import highcharts from '@/../static/js/highchart'

  export default {
    props: ['idEvaluacion', 'idSolicitud'],//Recibe como parametro el id de evaluación
    data() {
      return this.datosIniciales()
    },
    components: {
      highcharts
    },
    methods: {
      datosIniciales() {
        return {//asigna los valores iniciales del data
          nombreEvaluado: "",//Almacena el nombre del evaluado
          estatus: "Desconocido",//Almacena el estatusde la evaluación
          seccion: "",//Almacena la sección del evaluado
          departamento: "",//Almacena el departamento del evaluado
          puesto: "",//Almacena el puesto del evaluado
          tipoPuesto: "",//Almacena el tipo de contrato del evaluado
          periodoEvaluacion: "",//Almacena el periodo de evaluación
          evaluadoresAsignados: 0,//Almacena la cantidad de evaluadores asignados
          evaluadoId: 0,//Guarda el id del evaluado
          asignadosIniciales: false,
          evaluadores: [],
          leyendas: [],
          leyendasEspecificas: [],
          banderasLeyendas: [],
          comentario: "",
          textoBusquedaLeyendas: "",
          terminado: false,
          comentado: false,
          competencias: ['Autocontrol y estabilidad emocional',
            'Confianza y seguridad en sí mismo',
            'Resistencia a la adversidad',
            'Comunicación',
            'Establecimiento de relaciones',
            'Negociación',
            'Trabajo en equipo',
            'Iniciativa',
            'Orientación a resultados',
            'Capacidad de análisis',
            'Toma de decisiones',
            'Conocimiento de la institución',
            'Orientación al usuario',
            'Apertura',
            'Identificación con la institución',
            'Visión y Anticipación',
            'Dirección',
            'Liderazgo',
            'Planificación y organización'
          ],
          Fortalezas: [],
          Oportunidades: [],
          filtroFortalezas: true,
          filtroAreasDeOportunidad: true,
          filtroComentariosNegativos: null,
          chartOptions: {
            chart: {
              renderTo: 'container',
              polar: true,
              type: 'line',
              backgroundColor: 'transparent'
            },
            title: {
              text: 'Resultado de Evaluación',
              x: 0,
              style: {
                color: "#fff"
              }
            },
            pane: {
              size: '100%'
            },
            xAxis: {
              categories: ['IntraPersonal', 'Interpersonal', 'Desarrollo de tareas', 'Entorno', 'Gerencia'],
              tickmarkPlacement: 'on',
              lineWidth: 0,
              labels: {
                style: {
                  color: "#fff"
                }
              }
            },

            yAxis: {
              tickInterval: 1,
              gridLineInterpolation: 'polygon',
              lineWidth: 0,
              min: 0,
              max: 4,
              labels: {
                style: {
                  color: "#fff"
                }
              }
            },

            tooltip: {
              shared: true
            },

            legend: {
              align: 'right',
              verticalAlign: 'top',
              y: 80,
              layout: 'vertical',
              itemStyle: {
                color: '#FFF'
              }
            },
            exporting: {
              buttons: {
                contextButton: {
                  symbolStroke: "white",
                  theme: {
                    fill: "transparent"
                  }
                }
              }
            },

            series: [{
              name: 'Perfil del Puesto',
              type: 'line',
              dashStyle: 'ShortDash',
              data: [3, 3.4, 2.5, 3.1, 3.5],
              pointPlacement: 'on',
              color: '#FF11AA',
            },
            {
              name: 'Resultado',
              type: 'line',
              data: [3.5, 3, 3.2, 2.3, 4],
              pointPlacement: 'on',
              color: '#0088FF'
            }
            ]

          },
          chartOptions2: {
            chart: {
              type: 'column',
              backgroundColor: 'transparent'
            },
            title: {
              text: 'Resultado de Evaluación',
              style: {
                color: "#fff"
              }
            },
            subtitle: {
              text: 'Competencias',
              style: {
                color: "#fff"
              }
            },
            xAxis: {
              categories: ['Autocontrol y estabilidad emocional', 'Confianza y seguridad en sí mismo', 'Resistencia a la adversidad', 'Comunicación', 'Establecimiento de relaciones', 'Negociación', 'Trabajo en equipo', 'Iniciativa', 'Orientación a resultados', 'Capacidad de análisis', 'Toma de decisiones', 'Conocimiento de la institución', 'Orientación al usuario', 'Apertura', 'Identificación con la institución', 'Dirección', 'Liderazgo', 'Planificación y organización', 'Visión y Anticipación'],
              crosshair: true,
              labels: {
                style: {
                  color: "#fff"
                }
              }
            },
            yAxis: {
              min: 0,
              max: 4,
              title: {
                text: 'Puntaje',
                style: {
                  color: "#fff"
                }
              },
              labels: {
                style: {
                  color: "#fff"
                }
              }
            },
            tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
            },
            legend: {
              itemStyle: {
                color: '#FFF'
              }
            },
            plotOptions: {
              column: {
                pointPadding: 0.2,
                borderWidth: 0
              }
            }, exporting: {
              buttons: {
                contextButton: {
                  symbolStroke: "white",
                  theme: {
                    fill: "transparent"
                  }
                }
              }
            },
            series: [{
              name: 'Perfil del Puesto',
              data: [3.2, 2.4, 2, 1.7, 3, 3.1, 3.3, 2.7, 2, 3.1, 3, 2, 1.5, 1.4, 1.8, 3, 3.5, 2]

            }, {
              name: 'Resultado',
              data: [],
              color: '#cfcdcc'

            }]

          }
        }


      },
      cargarDatosEvaluacion: function () {//Hace la petición para recibir los datos generales sobre la evaluación a mostrar
        //Carga los datos para hacer la peticion
        var peticion = {
          "esPrueba": false,
          "idEvaluacion": this.idEvaluacion
        };
        axios.post(api.conexion + api.SISEVA.funcion.GetEvaluacion, peticion).then(response => {
          if (response.data.SiHayError == false) {
            console.log(response.data)
            var evaluacion = response.data.evaluacion
            this.estatus = evaluacion.Estatus
            if (this.estatus == "Terminado") {
              this.terminado = true
            }
            var evaluadores = response.data.evaluacion.evaluadores
            this.asignadosIniciales = (evaluadores.length > 0)
            if (this.asignadosIniciales) {
              this.buscarEvaluadoresAsignados();
            }
            this.nombreEvaluado = evaluacion.nombreEvaluado
            this.seccion = evaluacion.Seccion
            this.departamento = evaluacion.Departamento
            this.puesto = evaluacion.Puesto
            this.tipoPuesto = evaluacion.TipoPlaza
            this.periodoEvaluacion = evaluacion.FechaInicioPeriodoEvaluacionString + " - " + evaluacion.FechaFinPeriodoEvaluacionString
            this.evaluadoresAsignados = evaluacion.noCuestionarios
            this.evaluadoId = evaluacion.EvaluadoId
            this.comentario = evaluacion.ObservacionRH
            if (evaluacion.PerfilCategorias[4] == null) {
              this.chartOptions.xAxis.categories.splice(4, 1)
              evaluacion.PerfilCategorias.splice(4, 1)
              evaluacion.ResultadoCategorias.splice(4, 1)
            }
            this.chartOptions.series[0].data = evaluacion.PerfilCategorias
            this.chartOptions2.series[0].data = evaluacion.PerfilCompetencias
            this.chartOptions.series[1].data = evaluacion.ResultadoCategorias
            this.chartOptions2.series[1].data = evaluacion.ResultadoCompetencias

            if (this.comentario != null) {
              this.comentado = true
            }
            var PerfilCompetencias = evaluacion.PerfilCompetencias
            var Fortalezas = []
            var Oportunidades = []
            var competencias = this.competencias
            evaluacion.ResultadoCategorias.forEach(function callback(currentValue, index, array) {
              if (currentValue != null) {
                if (currentValue > PerfilCompetencias[index]) {
                  Fortalezas.push(competencias[index])
                } else if (currentValue + 1.5 < PerfilCompetencias[index]) {
                  Oportunidades.push(competencias[index])
                }
              }
            });
            this.Fortalezas = Fortalezas
            this.Oportunidades = Oportunidades
            this.filtroFortalezas = this.Fortalezas.length > 0
            this.filtroAreasDeOportunidad = this.Oportunidades.length > 0
            //Extrae los resultados de la petición pára insertarlos en la vista
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      buscarEvaluadoresAsignados: function () {//Hace la petición para obtener a los evaluadores de la evaluación
        //Carga los valores requeridos para hacer la petición
        var peticion = {
          "esPrueba": false,
          "idEvaluacion": this.idEvaluacion
        };
        axios.post(api.conexion + api.SISEVA.funcion.GetEvaluadores, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa

            this.evaluadores = response.data.evaluadores//Carga los datos requeridos

          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      }, cargarResultadosEvaluacion: function () {//Hace la petición para recibir los datos generales sobre la evaluación a mostrar
        //Carga los datos para hacer la peticion
        var peticion = {
          "esPrueba": false,
          "EvaluacionId": this.idEvaluacion
        };
        axios.post(api.conexion + api.SISEVA.funcion.GetResultadoEvaluacion, peticion).then(response => {
          if (response.data.SiHayError == false) {
            this.chartOptions.series[1].data = response.data.ResultadoCategorias
            this.chartOptions.xAxis.categories = response.data.NombreCategorias
            this.chartOptions2.series[1].data = response.data.ResultadoCompetencias
            this.chartOptions2.xAxis.categories = response.data.NombreCompetencias
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      guardarComentario: function () {
        var peticion = {
          "esPrueba": false,
          "EvaluacionId": this.idEvaluacion,
          "comentario": this.comentario
        };
        axios.post(api.conexion + api.SIAP.funcion.GuardarComentarioEvaluacion, peticion).then(response => {
          if (response.data.SiHayError == false) {
            comun.mensajeDeAlerta("Comentario guardado correctamente", null, null)
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      buscarLeyendas: function () { //Retorna una lista de cuestionarios en base a ciertos filtros
        var peticion = {
          "esPrueba": false
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.GetLeyendasRetroalimentacionGenericas, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.leyendas = response.data.LeyendasRetroalimentacion//Carga los datos necesarios

            comun.SeEstaCargandoInformacion(false);
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      buscarLeyendasEspecificas: function () { //Retorna una lista de cuestionarios en base a ciertos filtros
        var peticion = {
          "esPrueba": false
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.GetLeyendasRetroalimentacionEspecificas, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.leyendasEspecificas = response.data.LeyendasRetroalimentacionEspecificas//Carga los datos necesarios
            var i;
            for (i = 0; i < this.leyendasEspecificas; i++) {
              this.banderasLeyendas.push(false)
            }
            comun.SeEstaCargandoInformacion(false);
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      actualizarComentario: function () {
        var leyendasAgregadas = "";
        var i;
        var separacion = " ";
        for (i = 0; i < this.banderasLeyendas.length; i++) {
          if (this.banderasLeyendas[i]) {
            leyendasAgregadas += separacion + this.leyendasEspecificas[i].Leyenda
            separacion = ", ";
          }
        }
        this.calificarComentarios(this.filtroComentariosNegativos);
        this.comentario += leyendasAgregadas+".";
      },
      agregarLeyenda: function () {
        var i = 0;
        for (i = 0; i < this.leyendas.length; i++) {
          //console.log(this.leyendas[i]);
          this.comentario = "";
          if (this.leyendas[i].Fortalezas == this.filtroFortalezas && this.leyendas[i].AreasDeOportunidad == this.filtroAreasDeOportunidad && this.leyendas[i].ComentariosNegativos == this.filtroComentariosNegativos) {
            this.comentario = this.leyendas[i].Leyenda;
            break;
          }
          //console.log(this.leyendas[i].mostrar)
          //this.$forceUpdate();
        }
      },
      calificarComentarios: function (val) {
        if (!val) {
          $("#bueno").css("color", "green");
          $("#malo").css("color", "white");
        } else {
          $("#bueno").css("color", "white");
          $("#malo").css("color", "red");
        }
        //console.log(val)
        this.filtroComentariosNegativos = val;
        this.agregarLeyenda();
      }
    },
    computed: {

    },
    watch: {

    }, mounted: function mounted() {//Carga la información de la evaluación y la lista de cuestionarios al principio
      this.cargarDatosEvaluacion();
      this.buscarLeyendas();
      this.buscarLeyendasEspecificas();
      //this.cargarResultadosEvaluacion();
    }

  }

</script>

<style scoped>
  .leyenda {
    height: 50px;
    border-bottom: solid;
    border-bottom-color: white;
    padding-top: 10px;
    background-color: #3a3a3d;
  }

  .scroll {
    overflow-y: auto;
    height: 300px;
    border-radius: 25px;
  }

  .up-selected {
    color: green;
  }

  .down-selected {
    color: red;
  }

  i {
    cursor: pointer;
  }
  .thead-custom {
    background-color: #004746;
    color: white;
  }
  .custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/SIAP/Evaluaciones/DetalleEvaluacion.vue